(()=>{
  const SOURCE='AXION_CONFIGURATOR_DEV';
  const CONTROLLER_ROLE='controller';
  const shopRoot=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  let locked=true;
  let repairing=false;

  const route=path=>shopRoot+String(path||'').replace(/^\//,'');

  const fetchJson=async(path,options={})=>{
    const response=await fetch(route(path),{
      credentials:'same-origin',
      headers:{
        Accept:'application/json',
        ...(options.body?{'Content-Type':'application/json'}:{}),
        ...(options.headers||{})
      },
      ...options
    });
    const result=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(result.description||result.message||`Errore carrello ${response.status}`);
    return result;
  };

  const analyze=cart=>{
    const items=Array.isArray(cart?.items)?cart.items:[];
    const axionItems=items.filter(item=>item?.properties?._axion_source===SOURCE);
    const controllers=axionItems.filter(item=>item?.properties?._axion_role===CONTROLLER_ROLE);
    const controllerIds=new Set(
      controllers
        .map(item=>String(item?.properties?._axion_config_id||'').trim())
        .filter(Boolean)
    );
    const orphans=[];
    const ambiguous=[];

    axionItems.forEach(item=>{
      if(item?.properties?._axion_role===CONTROLLER_ROLE)return;
      const id=String(item?.properties?._axion_config_id||'').trim();

      if(controllers.length===0||(id&&!controllerIds.has(id))){
        if(item?.key)orphans.push(item);
        return;
      }

      if(!id)ambiguous.push(item);
    });

    return {orphans,ambiguous,controllers};
  };

  const isCheckoutTarget=target=>{
    if(!(target instanceof Element))return false;
    return Boolean(target.closest(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout], .ax-checkout'
    ));
  };

  document.addEventListener('click',event=>{
    if(!locked||!isCheckoutTarget(event.target))return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  },true);

  document.addEventListener('submit',event=>{
    if(!locked)return;
    const form=event.target;
    const submitter=event.submitter;
    const checkoutSubmit=submitter?.name==='checkout'||Boolean(
      form?.querySelector?.('button[name="checkout"], input[name="checkout"], [data-checkout], .ax-checkout')
    );
    if(!checkoutSubmit)return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  },true);

  const getStatusHost=()=>document.querySelector('.axc-summary, .axc-empty, #MainContent');

  const getStatusNode=()=>{
    let node=document.getElementById('axion-cart-integrity-status');
    if(node)return node;
    const host=getStatusHost();
    if(!host)return null;
    node=document.createElement('div');
    node.id='axion-cart-integrity-status';
    node.setAttribute('role','status');
    node.setAttribute('aria-live','polite');
    node.style.margin='0';
    node.style.display='none';
    node.style.color='#f8f8f3';
    node.style.fontSize='13px';
    node.style.fontWeight='700';
    node.style.lineHeight='1.45';
    node.style.textAlign='center';
    host.appendChild(node);
    return node;
  };

  const setStatus=message=>{
    const node=getStatusNode();
    if(!node)return;
    node.textContent=message||'';
    node.style.display=message?'block':'none';
    node.style.margin=message?'12px 0':'0';
  };

  const showRetry=(message,retry)=>{
    const node=getStatusNode();
    if(!node)return;
    node.style.display='block';
    node.style.margin='12px 0';
    node.replaceChildren();
    const text=document.createElement('span');
    text.textContent=message;
    const button=document.createElement('button');
    button.type='button';
    button.textContent='RIPROVA PULIZIA';
    button.style.display='block';
    button.style.margin='10px auto 0';
    button.style.padding='10px 18px';
    button.style.border='1px solid #d8ff3e';
    button.style.borderRadius='999px';
    button.style.background='#d8ff3e';
    button.style.color='#07100a';
    button.style.fontWeight='900';
    button.style.cursor='pointer';
    button.addEventListener('click',retry,{once:true});
    node.append(text,button);
  };

  const repair=async()=>{
    if(repairing)return;
    repairing=true;
    locked=true;

    try{
      const cart=await fetchJson('cart.js');
      const before=analyze(cart);

      if(before.ambiguous.length){
        throw new Error('Rilevata una riga AXION non collegata in modo sicuro. Il checkout resta bloccato per evitare un totale errato.');
      }

      if(!before.orphans.length){
        locked=false;
        setStatus('');
        return;
      }

      setStatus('Ripristino del carrello in corso…');
      const updates={};
      before.orphans.forEach(item=>{if(item.key)updates[item.key]=0});

      const updatedCart=await fetchJson('cart/update.js',{
        method:'POST',
        body:JSON.stringify({updates})
      });
      const after=analyze(updatedCart);

      if(after.orphans.length||after.ambiguous.length){
        throw new Error('Non è stato possibile ripulire completamente le righe AXION residue.');
      }

      window.location.reload();
    }catch(error){
      console.error('[AXION cart integrity DEV]',error);
      showRetry(
        error?.message||'Errore durante il ripristino del carrello.',
        ()=>{repairing=false;repair();}
      );
    }finally{
      if(!locked)repairing=false;
    }
  };

  repair();
})();
